export type ShareReportStatuses =
  (typeof ShareReportStatus)[keyof typeof ShareReportStatus]
export const ShareReportStatus = {
  Sent: 'SENT',
  Pending: 'PENDING',
  Failed: 'FAILED',
} as const

export type ReportExportFormats = 'CSV' | 'XLSX' | 'PDF'
export const ReportExportFormat = {
  Csv: 'CSV',
  Xlsx: 'XLSX',
  Pdf: 'PDF',
} as const satisfies Record<string, ReportExportFormats>
